import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import swal from 'sweetalert';
import { ContactoService } from '../../services/contacto.service';



@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.css']
})
export class ContactoComponent implements OnInit {

  objetoContacto = {};
  formContacto: FormGroup;
  submitted: boolean;
  msgError: string;
  EMAIL_PATTERN = '[a-zA-Z0-9.!#$%&"*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*';
  cargando: boolean;
  constructor(private formBuilder: FormBuilder, private _contactoService: ContactoService) {

    this.submitted = false;
    this.cargando = false;
    this.objetoContacto = {
      nombreContacto: ['', [Validators.required, Validators.minLength(5)]],
      rfcContacto: ['', [Validators.required, Validators.minLength(12), Validators.maxLength(13)]],
      emailContacto: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')]],
      telefonoContacto: ['', [Validators.pattern('^[0-9]{8,13}$')]],
      mensajeContacto: ['', [Validators.required]],
    };

   }

  ngOnInit() {
    this.formContacto = this.formBuilder.group(this.objetoContacto);
  }

 

  // Métodos
  onSubmitContacto(formulario) {

    this.submitted = true;
    if (this.formContacto.invalid) {// valida que el fomulario esté correcto
      this.msgError = `Favor de llenar correctamente los campos`;
      console.log(formulario);
      return;
    }

    const _this = this;

    _this.cargando = true;

    const datos = formulario.controls;
    const forma = new FormData();
    forma.append('nombre', datos.nombreContacto.value);
    forma.append('email', datos.emailContacto.value);
    forma.append('comentario', datos.mensajeContacto.value);
    forma.append('rfc', datos.rfcContacto.value);
    forma.append('telefono', datos.telefonoContacto.value);

    this._contactoService.enviarCorreo( forma )
    .subscribe( (resp) => {

      _this.cargando = false;
      console.log(resp);
      swal({
        title: 'Correcto',
        text: `La información ha sido enviada correctamente`,
        icon: 'success',
        timer: 2500,
         buttons: [false]
      }).then(() => {

        window.location.replace('#/inicio')
        return;
      });
    });
  }

  get e() { return this.formContacto.controls; }
}
